module.exports = __webpack_public_path__ + "static/media/Dollhouse_level_30.a630fa65.jpg";